var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bg-light min-vh-100",attrs:{"id":"app"}},[_c('router-view')],1),_c('base-loader-dialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }